import produce from 'immer';

import type { HomeGamesError } from '@swf/core/types/Poker';
import { PKR_INITIAL_STATE } from '@swf/poker';

export const setError = (
  state = PKR_INITIAL_STATE,
  { level, value }: { level: keyof HomeGamesError; value: boolean }
) =>
  produce(state, (draft) => {
    draft.error[level] = value;
  });
